/*
 * @Description: 内容审核 dto
 * @Author: 山淑兰
 * @Date: 2019-12-17 17:35:25
 * @LastEditTime: 2020-05-26 18:15:34
 * @LastEditors: 山淑兰
 */

/**
 * @title 报名配置
 * @date 2019-12-27
 */
export class GetSignupConfig {
  m: string = "";
}
/**
 * @title 获取验证码
 * @date 2019-12-27
 * @params {会议标识,手机号}
 */
export class ISendMsg {
  m: string = "";
  phone: string = "";
}
/**
 * @title 登录注册接口
 * @date 2019-12-27
 * @params {会议标识,手机号,验证码}
 */
export class IMobileReg {
  m: string = "";
  phone: string = "";
  code: string = "";
}
/**
 * @title 查询余票接口
 * @date 2019-12-27
 * @params {会议标识,手机号,验证码}
 */
export class IQuerySignRemaining {
  m: string = "";
  settypeid: number = -1;
}
/**
 * @title 获取用户报名信息接口
 * @date 2020-1-13
 */
export class IGetSignMeetingUser {
  m: string = "";
  muid: number = -1;
}
/**
 * @title 检查用户是否报名接口
 * @date 2020-1-13
 */
export class ICheckMeetingUserSign {
  m: string = "";
}
/**
 * @title 提交报名数据接口
 * @date 2020-01-15
 */
export class IPostSignMeetingUser {
  is_vip?: number;
  m: string = "";
  settypeid?: number;
  chid?: number;
  teamid?: number;

  UserEntity: any[] = [];
}
/**
 * @title 获取当前登录账户报名信息接口
 * @date 2020-01-16
 */
export class IGetSignMeetingUserByMu {
  m: string = "";
}
/**
 * @title 微信授权登录获取token接口
 * @date 2026-08-27
 * @params {微信授权回调生成的wxid}
 */
export class IVerWxLogin {
  wxid: string = "";
}
